import { useState } from "react";
import { Swords, Bomb, Target, Zap, Flame, Skull, Shield, Crown } from "lucide-react";

// Fighting themed emoji gestures
const FIGHT_GESTURES = [
  { emoji: "🔫", name: "Gun", category: "weapons" },
  { emoji: "💣", name: "Bomb", category: "weapons" },
  { emoji: "🏹", name: "Bow & Arrow", category: "weapons" },
  { emoji: "⚔️", name: "Swords", category: "weapons" },
  { emoji: "🗡️", name: "Dagger", category: "weapons" },
  { emoji: "🪓", name: "Axe", category: "weapons" },
  { emoji: "🔪", name: "Knife", category: "weapons" },
  { emoji: "💀", name: "Skull", category: "death" },
  { emoji: "☠️", name: "Crossbones", category: "death" },
  { emoji: "👊", name: "Punch", category: "actions" },
  { emoji: "🤜", name: "Right Punch", category: "actions" },
  { emoji: "🤛", name: "Left Punch", category: "actions" },
  { emoji: "👋", name: "Slap", category: "actions" },
  { emoji: "🦶", name: "Kick", category: "actions" },
  { emoji: "💥", name: "Explosion", category: "effects" },
  { emoji: "🔥", name: "Fire", category: "effects" },
  { emoji: "⚡", name: "Lightning", category: "effects" },
  { emoji: "💢", name: "Anger", category: "effects" },
  { emoji: "🩸", name: "Blood", category: "effects" },
  { emoji: "🤬", name: "Cursing", category: "faces" },
  { emoji: "😤", name: "Angry", category: "faces" },
  { emoji: "👿", name: "Devil", category: "faces" },
  { emoji: "🖕", name: "Middle Finger", category: "gestures" },
  { emoji: "🛡️", name: "Shield", category: "defense" },
  { emoji: "⛓️", name: "Chains", category: "weapons" },
  { emoji: "🧨", name: "Dynamite", category: "weapons" },
  { emoji: "🎯", name: "Target", category: "actions" },
  { emoji: "💀🔫", name: "Headshot", category: "combo" },
  { emoji: "⚔️💥", name: "Clash", category: "combo" },
  { emoji: "👊💥", name: "Knockout", category: "combo" },
];

const FightRoomGestures = ({ roomId, onInsertEmoji }) => {
  const [showPanel, setShowPanel] = useState(false);
  
  // Only show in fight rooms
  const isFightRoom = roomId === "fight-room" || roomId === "political-fight-room" || roomId?.includes("fight");
  if (!isFightRoom) return null;

  return (
    <div className="relative">
      {/* Toggle Button */}
      <button
        onClick={() => setShowPanel(!showPanel)}
        className={`retro-button p-1.5 ${showPanel ? 'bg-red-200' : ''}`}
        title="Fight Gestures"
      >
        <Swords className="w-4 h-4 text-red-600" />
      </button>

      {/* Gestures Panel */}
      {showPanel && (
        <div className="absolute bottom-full right-0 mb-2 w-64 bg-gray-900 rounded-lg border-2 border-red-600 shadow-xl z-50">
          <div className="bg-gradient-to-r from-red-700 to-red-900 text-white px-3 py-2 rounded-t-lg flex items-center justify-between">
            <span className="font-bold text-sm flex items-center gap-1">
              <Swords className="w-4 h-4" />
              FIGHT GESTURES
            </span>
            <button onClick={() => setShowPanel(false)} className="text-white hover:text-gray-300">✕</button>
          </div>
          
          <div className="p-2 max-h-48 overflow-y-auto">
            <div className="grid grid-cols-5 gap-1">
              {FIGHT_GESTURES.map((gesture, index) => (
                <button
                  key={index}
                  onClick={() => {
                    onInsertEmoji(gesture.emoji);
                    setShowPanel(false);
                  }}
                  className="p-2 hover:bg-gray-800 rounded transition-all text-xl"
                  title={gesture.name}
                >
                  {gesture.emoji}
                </button>
              ))}
            </div>
          </div>
          
          <div className="bg-gray-800 px-2 py-1 text-[10px] text-gray-400 text-center rounded-b-lg">
            Click to insert into message
          </div>
        </div>
      )}
    </div>
  );
};

export default FightRoomGestures;
